/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiClientsIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiClientsId200Schema = z.object({
  id: z.coerce.number().int().nullable().nullish(),
  name: z.coerce.string().min(1).max(500),
  enabled: z.boolean(),
  canHaveUnconfirmedProjects: z.boolean().nullable().nullish(),
  societa: z.array(
    z.object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    }),
  ),
});

export const getApiClientsIdQueryResponseSchema = z.lazy(
  () => getApiClientsId200Schema,
);
